class exports.BaseNeDB

    initialize: (data, callback = -> undefined) ->
        @db = new nedb()
        @db.insert data, callback
